import script from "./EntityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityPage.vue?vue&type=script&setup=true&lang=js"

import "./EntityPage.vue?vue&type=style&index=0&id=0d5bda26&lang=scss"

const __exports__ = script;

export default __exports__